/**
 * Reingreso físico de unidades con el egreso anulado "en tránsito": salieron
 * del depósito, se canceló la traza y vuelven. Quedan no disponibles (`na`)
 * hasta que se confirma que llegaron.
 */

import { z } from 'zod';

export const ReingresoPendienteSchema = z.object({
  stockId: z.number(),
  gtin: z.string().nullable(),
  serie: z.string().nullable(),
  lote: z.string().nullable(),
  /** `YYYY-MM-DD`. */
  vencimiento: z.string().nullable(),
  sku: z.string().nullable(),
  /** Remito del que salieron. */
  referencia: z.string().nullable(),
  anuladoAt: z.string().nullable(),
  anuladoPor: z.string().nullable(),
  trazaJobId: z.number().nullable(),
});

export const ReingresosPendientesResponse = z.object({
  unidades: z.array(ReingresoPendienteSchema),
});

export const ConfirmarReingresoResponse = z.object({
  reingresadas: z.number(),
  referencias: z.array(z.string()),
});

export type ReingresoPendiente = z.infer<typeof ReingresoPendienteSchema>;
export type ConfirmarReingresoResult = z.infer<typeof ConfirmarReingresoResponse>;
